export default __webpack_public_path__ + "static/media/target.24366193.svg";